namespace RioERP.Reports {
    export namespace OrderShippingReportService {
        export const baseUrl = 'Reports/OrderShippingReport';

        export declare function Create(request: Serenity.SaveRequest<OrderShippingReportRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<OrderShippingReportRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<OrderShippingReportRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<OrderShippingReportRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ScanBook(request: ScanBookRequest, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Reports/OrderShippingReport/Create",
            Update = "Reports/OrderShippingReport/Update",
            Delete = "Reports/OrderShippingReport/Delete",
            Retrieve = "Reports/OrderShippingReport/Retrieve",
            List = "Reports/OrderShippingReport/List",
            ScanBook = "Reports/OrderShippingReport/ScanBook"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'ScanBook'
        ].forEach(x => {
            (<any>OrderShippingReportService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
